var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{class:_setup.formLabelRecipe({ isRequired: _setup.props.isRequired }),attrs:{"data-component":"CsFormLabel","data-required":_setup.props.isRequired || undefined,"for":_setup.props.for || undefined}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }